<template>
  <div class="app-container" :class="{ 'sfr': isThemeSfr, 'beepiz': isThemeBeepiz, 'catsafe': isThemeCatsafe }">
    <router-view/>
    <Modal>
      <span slot="title" v-html="modalParams.title"></span>
      <component slot="content" :is="modalParams.component" :props="modalParams.props"></component>
    </Modal>
    <Confirm ref="confirm"></Confirm>
    <Messages/>
    <Loading/>
  </div>
</template>

<script>
import Loading from '@c/ui/Loading'
import Modal from '@c/ui/Modal'
import Confirm from '@c/ui/Confirm'
import Messages from '@c/ui/Messages'
import Utils from '@s/utils.js'
import {mapGetters} from 'vuex'

export default {
  name: 'App',
  components: {
    Loading,
    Messages,
    Modal,
    Confirm
  },
  data() {
    return {
      isThemeSfr: Utils.isThemeSfr(),
      isThemeCatsafe: Utils.isThemeCatsafe(),
      isThemeBeepiz: Utils.isThemeBeepiz(),
    }
  },
  mounted() {
    let titlePage = document.title;
    if (this.isThemeBeepiz) {
      document.title = titlePage.replace('SuiviDeFlotte.net', 'Beepiz')
    } else if (this.isThemeSfr) {
      document.title = titlePage.replace('SuiviDeFlotte.net', 'SFR Dati')
    } else if (this.isThemeCatsafe) {
      document.title = titlePage.replace('SuiviDeFlotte.net', "CAT'SAFE")
    }
  },
  created() {
    window.App = this;
  },
  computed: {
    ...mapGetters({
      modalParams: 'UI/modalParams'
    }),
  },
}
</script>

<style lang="scss">
@import '../node_modules/normalize-scss/sass/normalize/import-now';
@import 'assets/scss/main.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue